import styled from 'styled-components';
import { IconProps } from './CustomIcon.types';

export const Container = styled.div<IconProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width || '3rem'};
  height: ${({ height }) => height || '3rem'};
  min-width: ${({ width }) => width || '3rem'};
  min-height: ${({ height }) => height || '3rem'};
  border: ${({ $borderColor }) => ($borderColor ? `0.5rem solid ${$borderColor}` : 'unset')};
  background-color: ${({ $bgColor }) => $bgColor || 'transparent'};
  border-radius: ${({ $isRounded }) => ($isRounded ? '999px' : '0.5rem')};
`;
